<div class="modal-header" id="forms-duration-manual-input-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DURATION_MANUAL_INPUT_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row mb-3">
        <div class="col-sm-6 col-12">
            <label for="hoursInput" translate="DURATION_MANUAL_INPUT_HOURS"></label>
            <input
                type="number"
                id="hoursInput"
                [(ngModel)]="hours"
                [max]="maxHourAmount"
                class="form-control input-md number-input"
            />
        </div>
        <div class="col-sm-6 col-12 mt-4 mt-sm-0">
            <label for="minutesInput" translate="DURATION_MANUAL_INPUT_MINUTES"></label>
            <input
                type="number"
                id="minutesInput"
                [(ngModel)]="minutes"
                [max]="maxMinuteAmount"
                class="form-control input-md number-input"
            />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        translate="DURATION_STEPPER_CANCEL"
        (click)="modalInstance.hide()"
    ></button>
    <button class="btn btn-primary" type="button" translate="DURATION_STEPPER_DONE" (click)="onSave()"></button>
</div>
